<template>
  <v-layout row wrap>
    <!-- Dialog -->
    <v-dialog
      v-model="json_data.status"
      persistent
      max-width="300"
      transition="dialog-bottom-transition"
      :overlay="false"
    >
    <v-toolbar dark color="primary">
          <v-toolbar-title>
            <v-icon :size="20" class="px-2">fa-question-circle</v-icon>
            <span>{{$t('info.confirm_delete')}}</span>
          </v-toolbar-title>
          <v-spacer/>
          <v-tooltip bottom>
            <v-btn slot="activator" icon dark @click="closeDialog()">
              <v-icon>close</v-icon>
            </v-btn>
            <span>{{$t('close')}}</span>
          </v-tooltip>
        </v-toolbar>
      <v-card>
        
        <v-card-text>
          <v-layout row wrap pa-3>
          <v-flex xs12>
            <v-card-text>
              <div v-html="json_data.message"/>
            </v-card-text>
          </v-flex>
        </v-layout>
        </v-card-text>
        
        <v-divider></v-divider>
        <v-card-actions>
          <v-layout row wrap>
            <v-flex xs6 pa-1>
              <v-btn color="error" outline block @click="closeDialog()">{{$t('cancel')}}</v-btn>
            </v-flex>
            <v-flex xs6 pa-1>
              <v-btn color="success" outline block @click="onDelete();closeDialog();">{{$t('submit')}}</v-btn>
            </v-flex>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
/* eslint-disable */
export default {
  props: {
    json_data: Object
  },
  data: () => ({}),
  created: function() {},
  computed: {},
  methods: {
    closeDialog() {
      this.$emit("close-dialog");
    },
    onDelete() {
      this.$emit("delete-item");
    }
  }
};
</script>